import { type CSSProperties, type ReactNode } from 'react'
import type { IIconsVector } from 'shared/ui'

export type IAlertProps = {
  item: IAlert
  className?: string
  onClose?: () => void
  rightActions?: IAlertAction[]
  actions?: IAlertAction[]
  customActions?: ReactNode
  fullWidthCustomActions?: boolean
  marginTop?: CSSProperties['marginTop']
  marginBottom?: number
  marginInline?: number
  renderBottom?: (item: IAlert) => ReactNode
}

export type IAlertAction =
  | IAlertSwitchAction
  | IAlertButtonAction
  | IAlertLinkAction
  | IAlertNavLinkAction

type IAlertBaseAction = {
  type: 'primary' | 'secondary'
  text: string
  onClick?: () => void
}

export type IAlertButtonAction = IAlertBaseAction & {
  disabled?: boolean
  variant: 'button'
}

export type IAlertLinkAction = IAlertBaseAction & {
  variant: 'link'
  link: string
}

export type IAlertNavLinkAction = IAlertBaseAction & {
  variant: 'navLink'
  link: string
  appType: 'vue' | 'react'
}

export type IAlertSwitchAction = {
  variant: 'switch'
  onClick?: (value: boolean) => void
  value: boolean
  disabled?: boolean
}

export type IAlert = {
  type:
    | 'infoLight'
    | 'infoBlue'
    | 'error'
    | 'warning'
    | 'success'
    | 'alert'
    | 'infoStars'
    | 'infoStarsLight'
  title?: ReactNode
  desc?: ReactNode
  icon?: IIconsVector
  hideIcon?: boolean
  hideBorder?: boolean
  style?: CSSProperties
}

export const alertIconsByType: { [key in IAlert['type']]: IIconsVector } = {
  error: 'failed',
  warning: 'alertTriangleYellow',
  success: 'check2',
  infoLight: 'infoCircle',
  infoBlue: 'infoCircle',
  alert: 'alertTriangle',
  infoStars: 'stars',
  infoStarsLight: 'stars',
}
